import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import store from "@/store";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import {
	planTermList,
	planTermCreate,
	planTermDelete,
} from "@/common/api/rest/plan/term";

import { termList } from "@/common/api/rest/term/term";

import {
	breadcrumbSimple,
	baseConfirm,
	baseModal,
	baseTable,
	iconMenu,
	svgIcon,
} from "@/common/components";

import BaseSearch from "@/components/search/base-search.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'term',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const tableData = ref<any[]>([]);
const selected = ref<any>(null);
const payload = ref<any>(null);

const limit = ref<number>(6);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const loading = ref(false);

const terms = ref<any[]>([]);
const termSearch = ref<string>("");
const termSearched = ref(false);
const termLoading = ref(false);
const termLimit = ref<number>(6);
const termPage = ref<number>(0);
const termPages = ref<number>(0);
const termSelected = ref<any>(null);

const planId = computed(() => route.params.plan as string);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "plans",
		label: t("common.labels.plans"),
		url: "/register/plan",
	},
	{
		key: "edit",
		label: t("common.labels.edit"),
	},
]);

const menuList = computed(() => [
	{
		key: "infos",
		icon: "field",
		label: t("collection.labels.infos"),
		url: `/register/plan/${planId.value}/edit`,
	},
	{
		key: "price",
		icon: "no-image",
		label: "Preços",
		url: `/register/plan/${planId.value}/price`,
	},
	{
		key: "term",
		icon: "no-image",
		label: "Termos",
		url: `/register/plan/${planId.value}/term`,
	},
	{
		key: "module",
		icon: "no-image",
		label: "Módulos",
		url: `/register/plan/${planId.value}/module`,
	},
]);

const tableHeader = computed(() => [
	{ key: "code", label: t("common.labels.code") },
	{ key: "name", label: t("common.labels.name") },
	{ key: "status", label: t("common.labels.status") },
]);

const statusOptions = computed(() => ({
	ACTIVE: t("common.labels.active"),
	INACTIVE: t("common.labels.inactive"),
}));

async function changeMenu(url: string) {
	router.push(url);
}

function back() {
	router.push(`/register/plan`);
}

function fetchTerms(value?: string) {
	termSearch.value = value ?? "";

	termList({
		page: termPage.value,
		limit: termLimit.value,
		search: termSearch.value,
	})
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				terms.value = data.list.map((item) => ({
					id: item.term_id,
					label: item.name,
					value: item.term_id,
				}));
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function fetchData() {
	planTermList({
		plan_id: planId.value,
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				tableData.value = data.list;
				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function changePage(value: number) {
	page.value = value;
	fetchData();
}

function searchItem(value: string) {
	search.value = value;
	fetchData();
}

function addItem() {
	showModalAdd.value = true;
	termSearched.value = true;
}

function addItemCancel() {
	showModalAdd.value = false;
	termSearched.value = false;
	payload.value = null;
}

function selectTerm(option: any) {
	termSelected.value = option;
}

function addItemConfirm() {
	store.commit("SET_LOADING", true);

	const payload = {
		plan_id: planId.value,
		term_id: termSelected.value.value,
	};

	planTermCreate(payload)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				toast({ message: message, type: "success" });
				addItemCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function removeItem(data: any) {
	selected.value = data;
	showModalDel.value = true;
}

function removeItemCancel() {
	showModalDel.value = false;
	selected.value = null;
}

function removeItemConfirm() {
	if (!selected.value) return;

	planTermDelete(selected.value.item_id)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				toast({ message: message, type: "success" });
				removeItemCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

onMounted(() => {
	fetchData();
	fetchTerms();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "plans",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("plan.labels.plan_edit")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: "term",
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs"]),
        _createVNode(_unref(baseTable), {
          header: tableHeader.value,
          data: tableData.value,
          limit: limit.value,
          page: page.value,
          pages: pages.value,
          total: total.value,
          searched: searched.value,
          loading: loading.value,
          options: true,
          del: true,
          edit: true,
          "onChange:page": _cache[2] || (_cache[2] = ($event: any) => (changePage($event))),
          onSearching: _cache[3] || (_cache[3] = ($event: any) => (searchItem($event))),
          "onBtn:add": _cache[4] || (_cache[4] = ($event: any) => (addItem())),
          "onBtn:del": _cache[5] || (_cache[5] = ($event: any) => (removeItem($event)))
        }, {
          status: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(statusOptions.value[data.status]), 1)
          ]),
          _: 1
        }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "loading"]),
        _createVNode(_unref(baseModal), {
          class: "model-search",
          title: "ADICIONAR TERMO",
          "button-confirm": "Adicionar",
          "button-close": "Cancelar",
          show: showModalAdd.value,
          "show-button-confirm": true,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (addItemCancel())),
          onConfirm: _cache[7] || (_cache[7] = ($event: any) => (addItemConfirm()))
        }, {
          content: _withCtx(() => [
            _createVNode(BaseSearch, {
              label: "Buscar Termo",
              placeholder: "Ex: Termo de uso",
              search: termSearch.value,
              searched: termSearched.value,
              loading: termLoading.value,
              options: terms.value,
              optionLabel: "label",
              onSearch: fetchTerms,
              onSelect: selectTerm
            }, null, 8, ["search", "searched", "loading", "options"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_unref(baseConfirm), {
          show: showModalDel.value,
          title: "Remover Termo",
          message: `Você deseja remover o termo <strong>${selected.value?.name}</strong>?<br/>Esta ação não pode ser desfeita.`,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (removeItemCancel())),
          onConfirm: _cache[9] || (_cache[9] = ($event: any) => (removeItemConfirm()))
        }, null, 8, ["show", "message"])
      ])
    ])
  ]))
}
}

})